<div class="container formAddCustomer">
    <form [formGroup]="formCustomer" (ngSubmit)="submit()">
        <table>
            <tr>
                <td>
                    <mat-form-field appearance="standard">
                        <mat-label>ชื่อร้านค้า</mat-label>
                        <input matInput formControlName="name" placeholder="ป้าน้อย" required>
                    </mat-form-field>
                </td>
                <td>
                    <mat-form-field appearance="standard" required>
                        <mat-label>วันที่ไปขาย</mat-label>
                        <mat-select formControlName="day_of_week">
                            <mat-option value="1">วันจันทร์</mat-option>
                            <mat-option value="2">วันอังคาร</mat-option>
                            <mat-option value="3">วันพุธ</mat-option>
                            <mat-option value="4">วันพฤหัสบดี</mat-option>
                            <mat-option value="5">วันศุกร์</mat-option>
                            <mat-option value="6">วันเสาร์</mat-option>
                            <mat-option value="7">วันอาทิตย์</mat-option>
                        </mat-select>
                    </mat-form-field>
                </td>
            </tr>
            <tr>
                <td colspan="2">
                    <mat-form-field appearance="standard" style="width:100%">
                        <mat-label>ที่อยู่</mat-label>
                        <textarea formControlName="address" matInput placeholder="บ้านหนองไก่" required></textarea>
                    </mat-form-field>
                </td>
            </tr>
            <tr>
                <td colspan="2">
                    <mat-form-field appearance="standard" style="width:100%">
                        <mat-label>เบอร์โทร</mat-label>
                        <input matInput type="text" formControlName="phone_number" placeholder="088xxxxxx" maxlength="10">
                    </mat-form-field>
                </td>
            </tr>
            <tr>
                <td colspan="2" style="text-align:center">
                    <button mat-stroked-button color="primary" [disabled]="!formCustomer.valid" type="submit" *ngIf="!isEdit">สร้าง</button>
                    <button mat-stroked-button color="primary" type="button" *ngIf="isEdit" (click)="update()">แก้ไข</button>
                    <button mat-stroked-button color="primary" type="button" *ngIf="isEdit" (click)="cancelEdit()">ยกเลิก</button>
                </td>
            </tr>
        </table>
    </form>
</div>
<div>
    <table mat-table [dataSource]="dataSource" class="customerTable">
        <!-- Name Column -->
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef> ชื่อร้านค้า </th>
          <td mat-cell *matCellDef="let element"> {{element.name}} </td>
        </ng-container>
    
        <!-- Weight Column -->
        <ng-container matColumnDef="address">
          <th mat-header-cell *matHeaderCellDef> ที่อยู่ </th>
          <td mat-cell *matCellDef="let element"> {{element.address}} </td>
        </ng-container>
    
        <!-- Symbol Column -->
        <ng-container matColumnDef="day_of_week">
          <th mat-header-cell *matHeaderCellDef> วันที่ไปขาย </th>
          <td mat-cell *matCellDef="let element"> {{ day(element.day_of_week) }} </td>
        </ng-container>

        <ng-container matColumnDef="option">
            <th mat-header-cell *matHeaderCellDef> ตัวเลือก </th>
            <td mat-cell *matCellDef="let element"> <mat-icon (click)="edit(element)" class="link">edit</mat-icon> </td>
          </ng-container>
    
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
</div>